// Shared status options for storage areas (stockpiles & containment pads).
// Mirrors the dashboard categories described in the Rubble/Stockpile plan.
export const STORAGE_AREA_STATUSES = [
  "Active",
  "To Be Sampled",
  "Pending",
  "Closed",
];
